import { DropdownComponent } from './dropdown/dropdown.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import {
  FormParameterComponent,
  CommonCloudStudioModule
} from 'common-cloudstudio';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { PanelComponent } from './panel/panel.component';
import { AccordionComponent } from './accordion/accordion.component';
import { TableComponent } from './table/table.component';
import { CustomTableComponent } from './custom-table/custom-table.component';
import { TooltipModule} from 'ngx-bootstrap/tooltip';
import { DropdownService } from './dropdown/dropdown.service';
import { DropItemComponent } from './dropdown/drop-item/drop-item.component';
import { FormsModule } from '@angular/forms';
import { InputRangeComponent } from './input-range/input-range.component';
import { MapService } from './services/map.service';


@NgModule({
  declarations: [PanelComponent, AccordionComponent, TableComponent, CustomTableComponent, DropdownComponent, DropItemComponent, InputRangeComponent],
  imports: [CommonModule, BsDropdownModule, CommonCloudStudioModule, FormsModule, TooltipModule,],
  exports: [PanelComponent, AccordionComponent, TableComponent, CustomTableComponent, DropdownComponent, DropItemComponent, InputRangeComponent],
  providers: [DropdownService, MapService]
})
export class SharedModule {}
